import { render, staticRenderFns } from "./CountryEdit.vue?vue&type=template&id=afacd29e&scoped=true"
import script from "./CountryEdit.vue?vue&type=script&lang=js"
export * from "./CountryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afacd29e",
  null
  
)

export default component.exports